import { combineReducers } from 'redux';

/**
 * Import reducers
 */
import app from './app';
import wgw from './wgw';
import config from './config';
import campaign from './campaign';


const rootReducer = combineReducers({
  app, // Application main data
  wgw, // What goes where data
  config, // Application configs like lang
  campaign, // Application campaign stuff
});


export default rootReducer;
